import React from 'react';
import { Navbar } from "react-bootstrap";
import SideNav from '../sidenav/index';
import AdminMenu from '../admin-menu';
import igniteLogo from '../../assets/img/ignite_logo_alt.png';

const AdminNavigation = ({ children }) => (
  <Navbar fluid collapseOnSelect className="custom-sidebar">
    <Navbar.Header id="navbar-header">
      <Navbar.Brand className="sidebar-brand">
        <img src={igniteLogo} alt="Ignite Logo" title="Ignite logo"/>
      </Navbar.Brand>
      <Navbar.Toggle/>
    </Navbar.Header>

    <Navbar.Collapse>
      <SideNav admin/>
    </Navbar.Collapse>

    <AdminMenu/>

    {children}
  </Navbar>
);

export default AdminNavigation;



// WEBPACK FOOTER //
// ./src/components/layout/admin-navigation.jsx